var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"filter-title"},[_vm._v("Course")]),_vm._v(" "),_vm._l((_vm.$store.state.event.data.list_courses),function(course){return _c('router-link',{key:course,staticClass:"button_course",class:{
      isCurrent: _vm.$store.state.event.selection.course === course,
    },attrs:{"type":"button","size":"sm","target":"_self","to":{
        name: 'Epreuve',
        query: { id: _vm.$store.state.event.id, p: course },
      },"refresh":""}},[_vm._v(_vm._s(course))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }